export default "/_next/static/chunks/fonts/symbols_pattyn-ec55b578e5fdb05ee12119dc6bf54c3b.woff";